<template>
	<div id="list-tours">
		<h1>Percursos</h1>
		<b-list-group>
			<b-list-group-item
				class="d-flex justify-content-between align-items-center"
				v-for="(tour,index) in toursList"
				:key="index"
			>
				<b-container>
					<b-row>
						<b-col lg="8">{{tour.title}}</b-col>
						<b-col>
							<div class="mt-3">
								<b-button-group>
									<b-button variant="info" @click="flipViewFlags(index)">Ver</b-button>
									<b-button variant="info" @click="flipEditFlag(index,tour)">Alterar</b-button>
									<b-button variant="info" @click="$bvModal.show('my-modal-tour'+tour.id)" >Remover</b-button>
                  <b-modal :id="'my-modal-tour'+tour.id" title="Apagar Percurso" @ok="deleteTour(tour.id)">Apagar {{tour.title}} ?</b-modal>
								</b-button-group>
							</div>
						</b-col>
					</b-row>
					<b-row lg="10">
						<b-col>
							<div v-if="viewingFlags[index]">
                <form-tour editingMode="view" :tour="tour"></form-tour>
							</div>
							<div v-if="editingFlag - 1 == index">
                <form-tour editingMode="edit" :tour="tour"></form-tour>
							</div>
						</b-col>
					</b-row>
				</b-container>
			</b-list-group-item>
		</b-list-group>
	</div>
</template>

<script>
import formTour from './formTour'
import { mapGetters, mapActions } from 'vuex'
import api from '../../api'
export default {
  name: "listTours",
  components: {formTour},
	data() {
		return {
			viewingFlags: [],
			editingFlag: 0,
		};
	},
	mounted() {
		this.refreshData();
  },
  computed:{
    ...mapGetters(['toursList'])
  },
	methods: {
    ...mapActions(['refreshTours']),
		deleteTour(index) {
			api.deleteTour({ id: index }).then(() =>
      this.refreshData()
      )

		},
		refreshData() {
    this.refreshTours().then(() => {
      for (var i = 0; i < this.toursList.length; i++) {
        this.viewingFlags[i] = false;
      }
    })
		},
		flipViewFlags: function(index) {
			if (index + 1 !== this.editingFlag) {
				this.$set(this.viewingFlags, index, !this.viewingFlags[index]);
			}
		},
		flipEditFlag: function(index, tour) {
			if (index + 1 !== this.editingFlag) {
				this.viewingFlags[index] = false;
				this.editingFlag = index + 1;
			} else {
				this.editingFlag = 0;
			}
		}
	}
};
</script>
<style script="css">
#list-tours {
	text-align: left;
}
</style>

